export default "__VITE_ASSET__C2yaG1fr__"